module.exports = __webpack_public_path__ + "media/images/example-pdf-bf0a392f9a62f7b0a55f20abd7ccb524.png";